import { ReformulationDto, ReformulationResponseDto } from "@/app/Data/DTO/reformulationDto";
import { Observable } from "rxjs";

export abstract class IReformulateTextRepository {
    constructor() { }
    abstract reformulate(request: ReformulationDto): Observable<ReformulationResponseDto>;
}